import {
  JupiterTheme,
  MockHook,
  darkThemeStyles,
  UserAvatar,
  FeatureFlagsContext,
} from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import clsx from 'clsx';
import { TextField } from '@material-ui/core';

import MfaSettings from './MfaSettings';
import UserDefaultAppSelector from './UserDefaultAppSelector';

import useUserProfilePageLogic, {
  UserProfilePageComponentProps,
} from './useUserProfilePageLogic';

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    ...darkThemeStyles,
    container: {
      alignItems: 'center',
      display: 'flex',
      flexFlow: 'column',
      height: '100%',
      width: '100%',
    },
    white: { color: theme.palette.common.white },
    spinnerCenter: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto',
      padding: '40px',
      height: '100%',
      width: '100%',
      textAlign: 'center',
    },
    form: {
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(5),
    },
    fadeIn: {},
  });
});

export const UserProfilePageComponent = ({
  profileName,
  email,
  handleNameChange,
}: UserProfilePageComponentProps) => {
  const classes = useStyles();

  const InputLabelProps = {
    className: classes.textInputLabel,
    classes: {
      disabled: classes.textInputLabelDisabled,
      focused: classes.textInputLabelFocused,
    },
  };
  const InputProps = {
    className: classes.textInput,
    classes: {
      disabled: classes.disabled,
      icon: classes.white,
    },
  };

  return (
    <div className={clsx(classes.container, classes.fadeIn)}>
      <UserAvatar name={profileName} size="5rem" fontSize="3rem" />
      <form className={classes.form}>
        <TextField
          id="email"
          label="Email"
          value={email || ''}
          className={(classes as any).textField}
          InputLabelProps={InputLabelProps}
          InputProps={InputProps}
          margin="normal"
          fullWidth
          disabled
        />
        <TextField
          id="name"
          label="Name"
          value={profileName}
          className={(classes as any).textField}
          InputLabelProps={InputLabelProps}
          InputProps={InputProps}
          margin="normal"
          fullWidth
          onChange={handleNameChange}
        />
        <UserDefaultAppSelector />
      </form>
      <FeatureFlagsContext.Consumer>
        {({ hasFeature }) => hasFeature('mfaConfiguration') && <MfaSettings />}
      </FeatureFlagsContext.Consumer>
    </div>
  );
};

export default MockHook.withHookHoc(
  UserProfilePageComponent,
  useUserProfilePageLogic
);
